// src/data/subjects.js
//
// One definition of the four subjects, used by the dashboards and the
// dynamic portal.
//
// The dashboards used to derive their label with
// `subject.charAt(0).toUpperCase() + subject.slice(1)`, which turns
// "socialstudies" into "Socialstudies" — no space, wrong capitalisation.
// The portal had a hand-written list with the correct "Social Studies".
// Two sources, two answers. This is the one.
//
// `value` is the URL/Firestore token and must not change: it's what
// /portal/:state/:grade/:subject and the layout IDs are built from.

export const SUBJECTS = [
  {
    value: "science",
    hint: "Experiments, nature & space",
    label: "Science",
    icon: "🔬",
    className: "sbl-tile-science",
  },
  {
    value: "socialstudies",
    hint: "People, places & history",
    label: "Social Studies",
    icon: "🌎",
    className: "sbl-tile-social",
  },
  {
    value: "math",
    hint: "Numbers, shapes & puzzles",
    label: "Math",
    icon: "🔢",
    className: "sbl-tile-math",
  },
  {
    value: "other",
    hint: "Art, music & more",
    label: "Other",
    icon: "🎨",
    className: "sbl-tile-other",
  },
];

export const SUBJECT_VALUES = SUBJECTS.map((s) => s.value);

// The subject buttons people actually see (dashboards + subject pages).
// "Other" is left off — it's no longer offered as its own button. It stays
// in SUBJECTS so old links, layouts and enrollment data keep working.
export const NAV_SUBJECTS = SUBJECTS.filter((s) => s.value !== "other");

const BY_VALUE = new Map(SUBJECTS.map((s) => [s.value, s]));

/**
 * Display name for a subject token. Falls back to a tidied version of the
 * token itself so an unrecognised subject renders as something readable
 * rather than blank.
 */
export function subjectLabel(value) {
  const known = BY_VALUE.get(String(value).toLowerCase());
  if (known) return known.label;

  return String(value || "")
    .replace(/[-_]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function subjectMeta(value) {
  return BY_VALUE.get(String(value).toLowerCase()) || null;
}
